import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { ExperimentalFeaturesService } from './experimental-features.service';

@Injectable({
    providedIn: 'root',
})
export class MetaService {
    constructor(
        @Inject(DOCUMENT) private document: Document,
        private experimentalFeaturesService: ExperimentalFeaturesService,
    ) {}

    isMEDProjectEnabled = this.experimentalFeaturesService.isMEDProjectActive;

    updateFavicon(): void {
        const faviconUrl = this.isMEDProjectEnabled ? 'med-favicon.ico' : 'favicon.ico';

        let link: HTMLLinkElement | null = this.document.querySelector("link[rel*='shortcut icon']");

        if (!link) {
            link = this.document.createElement('link');
            link.rel = 'icon';
            link.type = 'image/x-icon';
            this.document.head.appendChild(link);
        }

        link.setAttribute('sizes', 'any');
        link.href = faviconUrl;
    }
}
